import { useRef } from "react";
import styles from "./OTPinput.module.css";

const OTPInput = ({ length = 4, otp, setOtp, isWrong = false, isPending }) => {
  // const [currentIndex, setCurrentIndex] = useState<number>(0);
  const inputRefs = useRef([]);

  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
      // setCurrentIndex((prev) => (prev < length - 1 ? prev + 1 : prev));
    }

    // if (newOtp.every((digit) => digit !== "")) {
    //   onComplete(alert(newOtp.join("")));
    // }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        // Clear the current index
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move focus to the previous input if current is empty
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div
      className={`${styles.otpWrapper} ${
        isWrong && otp.every((digit) => digit !== "") ? styles.wrongOTP : ""
      }`}
    >
      {otp.map((digit, index) => (
        <input
          key={index}
          className={styles.otpInput}
          type="text"
          maxLength={1}
          value={digit}
          // onClick={(e) => {
          //   e.preventDefault();
          //   inputRefs.current[currentIndex]?.focus();
          // }}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          ref={(el) => (inputRefs.current[index] = el)}
          disabled={isPending}
        />
      ))}
    </div>
  );
};

export default OTPInput;
